// extracted by mini-css-extract-plugin
module.exports = {"checked":"SizeRadio_checked__EeGcs","checked-label":"SizeRadio_checked-label__7nztq"};